import {
  getCookie as cookiesNextGetCookie,
  getCookies as cookiesNextGetCookies,
} from "cookies-next";
import { OptionsType } from "cookies-next/lib/types";

interface GetCookieModel {
  key: string;
  options?: OptionsType;
}
interface GetCookiesModel {
  options?: OptionsType;
}

/**
 * getCookie() uses getCookies() under the hood.
 * Do opt for getCookies if you are trying to get multiple cookies.
 *
 * Detailed explanation:
 * - We are extending cookies-next package for all cookies utility functions.
 * - The time complexity of all operations is linear with the number of cookies.
 */
export const getCookie = ({ key, options }: GetCookieModel) => {
  const value = cookiesNextGetCookie(key, options);
  if (value) return value.toString();
  else return undefined;
};

export const getCookies = ({ options }: GetCookiesModel) => {
  const value = cookiesNextGetCookies(options);
  if (value) return value;
  else return undefined;
};
